"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.FudaoFactoryErrorName = "FudaoFactoryError";
class FudaoFactoryError extends CommonBaseError_1.CommonBaseError {
}
exports.FudaoFactoryError = FudaoFactoryError;
//# sourceMappingURL=IFudaoFactory.js.map